module.exports = __webpack_public_path__ + "static/img/case-kyj-page-bg-02.54e8d34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/kyj/case-kyj-page-bg-02.jpg
// module id = h7dZ
// module chunks = 1